import script from "./sf-document-pill.vue?vue&type=script&lang=ts&setup=true"
export * from "./sf-document-pill.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__